module.exports = __webpack_public_path__ + "static/img/section4-line3.75aa5aa6.png";